import Vue from 'vue';
import Swiper from 'swiper';

Vue.component('product-slider', {
    data() {
        return {
            swiperSlider: null,
        };
    },
    mounted() {
        this.initSwiper();
    },
    methods: {
        initSwiper() {
            this.swiperSlider = new Swiper('.swiper-container', {
                slidesPerView: 'auto',
                direction: 'horizontal',
                loop: true,
                centeredSlides: true,
                initialSlide: 3,
            });
        },
    },
});
